import Vue from 'vue'
import inViewportDirective from 'vue-in-viewport-directive'

import App from '@/App.vue'
import router from '@/router'
import store from '@/store/'
import '@/register-sw'
import Section from '@/components/Section'

Vue.config.productionTip = false
Vue.component('SectionMain', Section)

Vue.directive('in-viewport', inViewportDirective)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js